import {register} from "./register";
import {ExcalidrawElement, ExcalidrawTextElement} from "../element/types";
import {AppClassProperties, AppState} from "../types";
import {ToolButton} from "../components/ToolButton";
import {t} from "../i18n";
import {getShortcutKey} from "../utils";
import {isSomeElementSelected} from "../scene";
import {getNonDeletedElements, isTextElement} from "../element";
import {imgPathPerfix, isStringNullOrEmpty} from "../../../../src/utils";
import {Input} from "antd";
import {changeProperty, getFormValue} from "./actionProperties";
import {getBoundTextElement} from "../element/textElement";
import {DEFAULT_FONT_FAMILY} from "../constants";
import {newElementWith} from "../element/mutateElement";
import {KEYS} from "../keys";
import {useState} from "react";

let mInputValue = 0;
export const actionChangePosition = register({
    name:'changePosition',
    trackEvent:{category:'element'},
    perform:(elements, appState, formData, app) => {
        return {
            elements: changeProperty(elements, appState, (el) =>
                newElementWith(el, {
                    ...formData,
                }),
            ),
            appState: { ...appState},
            commitToHistory: true,
        };
    },
    contextItemLabel:"labels.changePosition",
    PanelComponent:({elements,appState,updateData,app})=>{
        const [x,setX] = useState(getFormValue(
            elements,
            appState,
            (element) => {
                // return Math.floor(element.x);
                if (element.extra?.tempX != undefined){
                    return (element.extra?.tempX);
                }
                return Math.floor(element.x);
            },
            (element) =>
                true,
            (hasSelection) =>
                0,
        ));
        const [y,setY] = useState(getFormValue(
            elements,
            appState,
            (element) => {
                if (element.extra?.tempY != undefined){
                    return (element.extra?.tempY);
                }
                return Math.floor(element.y);
            },
            (element) =>
                true,
            (hasSelection) =>
                0,
        ));
        return(
            <>
                {/*<h3 aria-hidden="true">{t("labels.changePosition")}</h3>*/}
                <div style={{display:'flex',height:'32px',alignItems:'center'}}>
                    <span className='text-color-666'>X</span>
                    <input style={{height:'26px',width:'86px',border:'0px solid var(--input-border-color)',background:'transparent',borderRadius:'3px',paddingLeft:'4px',marginLeft:'6px'}}
                           value={x}
                           onChange={(e)=>{
                               if (!isNumber(e.currentTarget.value) && !isStringNullOrEmpty(e.currentTarget.value))return;
                               var newValue:any = parseInt(e.currentTarget.value);
                               if (isNaN(newValue)){
                                   newValue = 0;
                               }
                               mInputValue = newValue;
                               if (e.currentTarget.value == '-'){
                                   newValue = '-';
                               }
                               if (isStringNullOrEmpty(e.currentTarget.value)){
                                   newValue = '';
                               }
                               setX(newValue);
                               //  updateData({x:newValue});
                               updateData({extra:{tempX:newValue}});

                           }}

                           onFocus={(event => {
                               mInputValue = parseInt(event.currentTarget.value)
                               event.currentTarget.select();
                               app.onPointDownEvent((activeTool,pointerDownState)=>{
                                   updateData({x:mInputValue,extra:{}});
                                   app.onPointDownEvent(null);
                               });
                           })}
                           onBlur={(event => {
                               updateData({x:mInputValue,extra:{}});
                           })}
                           onKeyDown={(event => {
                               if (event.key === KEYS.ENTER){
                                   if (!isNumber(event.currentTarget.value)){
                                       updateData({extra:{}})
                                   }else{
                                       updateData({x:parseInt(event.currentTarget.value)});
                                   }
                                   event.currentTarget.blur();
                               }
                           })}
                    />
                    <span className='text-color-666' style={{marginLeft:'6px'}}>Y</span>
                    <input style={{height:'26px',width:'64px',border:'0px solid var(--input-border-color)',background:'transparent',borderRadius:'3px',paddingLeft:'4px',marginLeft:'4px'}}
                           value={y}
                           onChange={(e)=>{
                               if (!isNumber(e.currentTarget.value) && !isStringNullOrEmpty(e.currentTarget.value))return;
                               var newValue:any = parseInt(e.currentTarget.value);
                               if (isNaN(newValue)){
                                   newValue = 0;
                               }
                               mInputValue = newValue;
                               if (e.currentTarget.value == '-'){
                                   newValue = '-';
                               }
                               if (isStringNullOrEmpty(e.currentTarget.value)){
                                   newValue = '';
                               }
                               setY(newValue);
                               // updateData({y:newValue});
                               updateData({extra:{tempY:newValue}});
                           }}
                           onFocus={(event => {
                               mInputValue = parseInt(event.currentTarget.value)
                               event.currentTarget.select();
                               app.onPointDownEvent((activeTool,pointerDownState)=>{
                                   updateData({y:mInputValue,extra:{}});
                                   app.onPointDownEvent(null);
                               });
                           })}
                           onBlur={(event => {
                               updateData({y:mInputValue});
                           })}
                           onKeyDown={(event => {
                               if (event.key === KEYS.ENTER){
                                   if (!isNumber(event.currentTarget.value)){
                                       updateData({extra:{}})
                                   }else{
                                       updateData({y:parseInt(event.currentTarget.value)});
                                   }
                                   event.currentTarget.blur();
                               }
                           })}
                    />
                </div>
            </>
        )
    }
})

const isNumber = (inputStr)=>{
    const reg = /^-?\d*(\.\d*)?$/;
    return (reg.test(inputStr));
}

const fixSizeElement = (
    elements:readonly ExcalidrawElement[],
    appState:AppState,
    formData,
    app:AppClassProperties
) => {
    var arrayNewElements = [...elements];
    for (var i=0;i<arrayNewElements.length;i++){
        var element = arrayNewElements[i];
        if (appState.selectedElementIds[element.id]) {
            arrayNewElements.splice(i,1);
            let newElement: ExcalidrawTextElement = newElementWith(element, {
                ...formData
            });
            return {
                elements:[...arrayNewElements,newElement],
                appState: {
                    ...appState
                }
            };
            break;
        }
    }
}























